import React from 'react'

import Box from 'components_new/atoms/Box'
import Skeleton from 'components_new/atoms/Skeleton'

import ThumbnailList from 'components_new/molecules/ThumbnailList'

const Loading = ({ skipTitle }: { skipTitle?: boolean }) => {
  return (
    <>
      <Box sx={{ mb: 8 }}>
        {skipTitle ? null : (
          <Box sx={{ mb: 1 }}>
            <Skeleton variant="rounded" width="32%" height={32} />
          </Box>
        )}
        <ThumbnailList itemSize={{ xs: 12, md: 6, lg: 4, xl: 4 }}>
          {[1, 2, 3].map((item) => (
            <Skeleton
              key={item}
              variant="rounded"
              width={'100%'}
              height={200}
            />
          ))}
        </ThumbnailList>
      </Box>
    </>
  )
}

Loading.displayName = 'Loading'

export default Loading
